import { NAV_LINKS, NavLinksConfig } from './links';

// BR-specific navigation configuration
export const brNavLinksConfig: NavLinksConfig = {
    agentNavLinks: [NAV_LINKS.AGENT_DASHBOARD, NAV_LINKS.SUBMISSIONS],
    accountManagerNavLinks: [NAV_LINKS.LUMEN_DASHBOARD, NAV_LINKS.SUBMISSIONS, NAV_LINKS.REPORTING, NAV_LINKS.GEO_FUSE],
    accountManagerConfigNavLinks: [NAV_LINKS.ORGANIZATIONS],
    adminNavLinks: [NAV_LINKS.LUMEN_DASHBOARD, NAV_LINKS.SUBMISSIONS, NAV_LINKS.REPORTING],
    adminConfigNavLinks: [
        NAV_LINKS.USERS,
        NAV_LINKS.ORGANIZATIONS,
        NAV_LINKS.DOCUMENT_TEMPLATES,
        NAV_LINKS.PROGRAM_SETUP,
    ],
    carrierRepNavLinks: [NAV_LINKS.SUBMISSIONS],
};
